import { CIMSFormItemProps } from '../../CIMSFormItem/types'
import { useGenericComment } from './useGenericComment'

/**
 * wraps {@link useGenericComment} for comments in the workflow rollback modal
 *
 * @see {@link useGenericComment}
 * @param options {@link UseWorkflowRollbackCommentOptions}
 * @example
 * <CIMSFormItem {...useWorkflowRollbackComment({ optional: true })}>
 *  <CIMSComment />
 * </CIMSFormItem>
 */
export function useWorkflowRollbackComment(
  options?: UseWorkflowRollbackCommentOptions
): Required<Pick<CIMSFormItemProps, 'label' | 'name'>> &
  Pick<CIMSFormItemProps, 'requiredMessage'> {
  const { optional } = options ?? {}
  return useGenericComment({
    required: optional ? false : { action: 'rollback' },
  })
}

export type UseWorkflowRollbackCommentOptions = {
  optional?: boolean
}
